import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
import { getFunctions, httpsCallable } from "firebase/functions";

// Admin-Firebase config (env eller hårdkodat)
const ADMIN_FIREBASE_CONFIG = {
  apiKey: process.env.REACT_APP_ADMIN_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_ADMIN_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_ADMIN_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_ADMIN_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_ADMIN_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_ADMIN_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_ADMIN_FIREBASE_MEASUREMENT_ID,
};

let tenantApp;
let db;
let auth;
let storage;
let functions;

/**
 * Initiera tenant Firebase dynamiskt
 */
export async function initTenantFirebase(clientId) {
  // 1️⃣ Initiera admin-app
  const adminApp = initializeApp(ADMIN_FIREBASE_CONFIG, "admin");
  const adminFunctions = getFunctions(adminApp, "europe-west1");

  // 2️⃣ Hämta tenantens config via callable
  const getClientConfig = httpsCallable(adminFunctions, "getClientConfig");
  const result = await getClientConfig({ clientId });
  const tenantConfig = result.data.config;

  // 3️⃣ Initiera tenant-app
  tenantApp = initializeApp(tenantConfig, "tenant");
  db = getFirestore(tenantApp);
  auth = getAuth(tenantApp);
  storage = getStorage(tenantApp);
  functions = getFunctions(tenantApp, "europe-west1");

  return { tenantApp, db, auth, storage, functions };
}

export { tenantApp, db, auth, storage, functions };
